import Reveal from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ_ITEMS = [
  {
    q: "como recebo acesso depois de comprar?",
    a: "é automático. depois do pagamento pela Hotmart, tu recebe as instruções de acesso ao app e ao grupo no WhatsApp/email cadastrado.",
  },
  {
    q: "quando começa o desafio?",
    a: "segunda, dia 27/07. todo mundo junto, mesma data.",
  },
  {
    q: "o que preciso fazer todo dia?",
    a: "marcar check-in de 4 hábitos no app: planejar o dia, exercício, cardio e leitura. sem meta mínima.",
  },
  {
    q: "o app já tá pronto?",
    a: "o EscapeFlow tá em beta e funcionando. ele evolui toda semana, então tu entra vendo ele crescer. acesso antecipado tem esse valor: tu chega antes.",
  },
  {
    q: "e se eu não conseguir fazer 100% dos dias?",
    a: "tranquilo. o desafio é sobre constância, não sobre perfeição. mesmo sem 100%, tu destrava a oferta fundadora da escape club.",
  },
  {
    q: "vai ter prêmio mesmo?",
    a: "sim. top 5 mais consistentes (por check-in no app) levam prêmios reais, de acesso anual à escape club até voucher de suplemento.",
  },
  {
    q: "o que é a escape club?",
    a: "a comunidade por trás do escape21. quem participa do desafio destrava a oferta fundadora com desconto quando ela abrir.",
  },
  {
    q: "posso pagar e não participar do dia 27?",
    a: "o acesso é liberado igual, mas o desafio é desenhado pra todo mundo começar junto. recomendo entrar na data.",
  },
];

const Faq = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-xl">
      <Reveal>
        <h2 className="text-center text-3xl font-extrabold tracking-[-0.03em] sm:text-5xl">
          perguntas frequentes
        </h2>
      </Reveal>
      <Reveal delay={120}>
        <Accordion type="single" collapsible className="mt-10">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`item-${i}`}
              className="border-b border-black/10"
            >
              <AccordionTrigger className="py-5 text-left text-base font-bold tracking-[-0.01em] hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-black/60 sm:text-base">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
